import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fl fs24" }, "外部カレンダー連携", -1)
const _hoisted_2 = {
  key: 0,
  class: "fl"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "w95 fl"
}
const _hoisted_6 = {
  class: "fl mt6",
  style: {"width":"calc(100% - 30px)"}
}
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "w95 fl",
  style: {"margin-bottom":"35px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "fw600 fs12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "mt40"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "ofa w100 fl"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, " カレンダー連携をしておくことで、 日時を都度入力せず、お相手に空いている時間のみを 自動的に提案できます。 ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = {
  href: "/sign_in/google",
  class: "AuthButton fl mr15 mb"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  href: "/sign_in/ms",
  class: "AuthButton fl"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PossibleDatesContent = _resolveComponent("PossibleDatesContent")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_SearchCalendarsContent = _resolveComponent("SearchCalendarsContent")!
  const _component_AttendeesGroupField = _resolveComponent("AttendeesGroupField")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ModalEditCalendarTag = _resolveComponent("ModalEditCalendarTag")!
  const _component_GroupProfileModal = _resolveComponent("GroupProfileModal")!
  const _component_ConnectZoomModal = _resolveComponent("ConnectZoomModal")!
  const _component_OptionModal = _resolveComponent("OptionModal")!

  return (_ctx.cm.astag)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(`AvailableTimeConnectedCalContent ofs ${_ctx.isSP ? `pad10` : `pad10`} rad8`),
        style: {"height":"calc(100vh - 110px)"}
      }, [
        (false && _ctx.cm.createType == `vote`)
          ? (_openBlock(), _createBlock(_component_PossibleDatesContent, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("section", {
          style: _normalizeStyle({
                height: `calc(100vh - 130px)`,
            }),
          class: _normalizeClass(`rad8 kakugo with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
        }, [
          _createElementVNode("div", null, [
            _hoisted_1,
            (_ctx.rm.didConnectCal && _ctx.cm.astag.can_connect_calendar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "fl",
                    style: {"margin-left":"10px"},
                    onTooltip: _cache[0] || (_cache[0] = ($event: any) => {;`${_ctx.rm.calendar_account_name}を利用`})
                  }, [
                    _createVNode(_component_Switcher, {
                      value: "type[disconnect]",
                      name: "外部カレンダーの利用",
                      checked: _ctx.cm.astag.can_connect_calendar,
                      display: "true",
                      class: "checkUsingCal fl",
                      onSelect: _ctx.changeConnectCalendar
                    }, null, 8, ["checked", "onSelect"])
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_3,
          _createElementVNode("section", null, [
            (_ctx.cm.showAttendeesEdit() || _ctx.showMagEvenIfNotConnectCal)
              ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                  (false && _ctx.cm.createType == `vote`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.edittingAttendees, (ctag, ctagindex) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "pad10 hoverLightGrey rad10 posRe",
                                style: {"height":"48px"},
                                key: `${ctagindex}${ctag.needVote}`
                              }, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(ctag.name), 1),
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                                  width: "25",
                                  height: "25",
                                  class: "posAb fr pointer mt1",
                                  style: {"right":"10px"},
                                  onClick: ($event: any) => (_ctx.deleteSelectCtag(ctag))
                                }, null, 8, _hoisted_7),
                                _hoisted_8
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createVNode(_component_SearchCalendarsContent),
                        _hoisted_9
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_draggable, {
                          modelValue: _ctx.cm.mags,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cm.mags) = $event)),
                          "item-key": `id`,
                          group: "fieldsGroup",
                          onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = true)),
                          onEnd: _ctx.sortEnd
                        }, {
                          item: _withCtx(({ element: mag, index: magindex }) => [
                            _createVNode(_component_AttendeesGroupField, {
                              mag: mag,
                              magindex: magindex,
                              editIndex: _ctx.editIndex,
                              purposeType: `normal`,
                              onFixedAttendees: _ctx.fixedAttendeesInGroup,
                              onEditGroup: _ctx.editGroup,
                              onAddNextGroupField: _ctx.addNextGroupField,
                              onDeleteGroup: _ctx.deleteGroup,
                              onAddProfile: _ctx.addProfile,
                              onAddZoom: _ctx.addZoom,
                              onShowOptionModal: _ctx.showOptionModal,
                              openModalEditCalendarTag: _ctx.openModalEditCalendarTag,
                              updateAttendees: _ctx.updateAttendees
                            }, null, 8, ["mag", "magindex", "editIndex", "onFixedAttendees", "onEditGroup", "onAddNextGroupField", "onDeleteGroup", "onAddProfile", "onAddZoom", "onShowOptionModal", "openModalEditCalendarTag", "updateAttendees"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onEnd"]),
                        _hoisted_12
                      ])),
                  _hoisted_13
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createTextVNode(" この調整カレンダーで "),
                    _hoisted_16,
                    _createTextVNode("連携済みのカレンダー"),
                    (_ctx.rm.calendar_account_name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "（" + _toDisplayString(`${_ctx.rm.calendar_account_name}`) + "）", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode("を利用します。 ")
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Switcher, {
                      value: "type[connectCal]",
                      name: "カレンダー連携",
                      checked: _ctx.cm.astag.can_connect_calendar,
                      display: "true",
                      class: "checkConnectingCal fl",
                      onSelect: _ctx.changeConnectCalendar
                    }, null, 8, ["checked", "onSelect"])
                  ]),
                  _hoisted_18,
                  (_ctx.showInstantRoomFields())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.mags, (mag, magindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${magindex}${mag.systemUpdatedAt}${_ctx.editIndex}`
                          }, [
                            _createVNode(_component_AttendeesGroupField, {
                              mag: mag,
                              magindex: magindex,
                              editIndex: _ctx.editIndex,
                              purposeType: `instant_room`,
                              onFixedAttendees: _ctx.fixedAttendeesInGroup,
                              onEditGroup: _ctx.editGroup,
                              onAddNextGroupField: _ctx.addNextGroupField,
                              onDeleteGroup: _ctx.deleteGroup,
                              onAddProfile: _ctx.addProfile,
                              onAddZoom: _ctx.addZoom,
                              onShowOptionModal: _ctx.showOptionModal,
                              openModalEditCalendarTag: _ctx.openModalEditCalendarTag,
                              updateAttendees: _ctx.updateAttendees
                            }, null, 8, ["mag", "magindex", "editIndex", "onFixedAttendees", "onEditGroup", "onAddNextGroupField", "onDeleteGroup", "onAddProfile", "onAddZoom", "onShowOptionModal", "openModalEditCalendarTag", "updateAttendees"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])),
            _hoisted_20
          ]),
          (!_ctx.rm.didConnectCal && _ctx.rcm.room && !_ctx.rcm.room.is_shared)
            ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                _createElementVNode("div", null, [
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("div", null, [
                    _createElementVNode("a", _hoisted_24, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/buttons/google_bnr.png`),
                        width: "260",
                        height: "58"
                      }, null, 8, _hoisted_25)
                    ]),
                    _createElementVNode("a", _hoisted_26, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/buttons/microsoft_bnr.png`),
                        width: "260",
                        height: "58"
                      }, null, 8, _hoisted_27)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_28,
          _createVNode(_component_ModalEditCalendarTag, {
            ctag: _ctx.editCtag,
            onEdit: _ctx.editEnd,
            autoLoadWeeklyCalendar: _ctx.autoLoadWeeklyCalendar
          }, null, 8, ["ctag", "onEdit", "autoLoadWeeklyCalendar"])
        ], 6),
        _createVNode(_component_GroupProfileModal, {
          magForProfile: _ctx.magForProfile,
          onSaveProfile: _ctx.saveProfile
        }, null, 8, ["magForProfile", "onSaveProfile"]),
        _createVNode(_component_ConnectZoomModal, {
          zoomLoctags: _ctx.zoomLoctags,
          magForProfile: _ctx.magForProfile,
          onSelectZoom: _ctx.selectZoom,
          onCancel: _ctx.cancelEdit
        }, null, 8, ["zoomLoctags", "magForProfile", "onSelectZoom", "onCancel"]),
        _createVNode(_component_OptionModal, {
          ref: "OptionModal",
          title: `オプション機能になります`,
          text: `ご利用になる場合、waaq担当者またはサポートまでお問い合わせください。`,
          eventName: _ctx.optionEventName,
          okButtonName: `課金リクエストする`,
          onClickOK: _ctx.clickOK,
          onClickCancel: _ctx.clickCancel
        }, null, 8, ["eventName", "onClickOK", "onClickCancel"]),
        _hoisted_29
      ], 2))
    : _createCommentVNode("", true)
}